export const crossFactionRaces = new Set<string>(['dracthyr', 'earthen', 'haranir', 'pandaren']);
